import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter  } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GlobalStateProvider } from "./Functions/GlobalStates";
import { HelmetProvider } from "react-helmet-async";

const root = createRoot(document.getElementById("root"));
if (root) {
  root.render(
    <BrowserRouter
      future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
    >
      {/* <React.StrictMode> */}
      <HelmetProvider>
        <GlobalStateProvider>
          <App />
        </GlobalStateProvider>
      </HelmetProvider>
      {/* </React.StrictMode> */}
    </BrowserRouter>
  );

  reportWebVitals();
} else {
  console.warn(
    "index.html is not rendered fix it from index.js file - root is not matched or value is null"
  );
}
